import { brandName } from "@/mocks/gossip";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const go = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  const navItems = [
    { href: "#feed", label: "现场围观" },
    { href: "#rank", label: "热瓜榜单" },
    { href: "#play", label: "玩法唠嗑" },
    { href: "#voices", label: "瓜友评论" },
    { href: "#faq", label: "常见问题" },
  ];

  return (
    <footer className="relative">
      {/* CTA banner */}
      <div className="bg-background-50 px-4 pb-16 md:px-6">
        <div className="relative mx-auto w-full max-w-6xl overflow-hidden rounded-3xl bg-primary-600 px-6 py-12 text-center md:py-16">
          <div className="pointer-events-none absolute -left-8 -top-10 h-40 w-40 rounded-full bg-accent-500/30 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-12 -right-6 h-44 w-44 rounded-full bg-background-50/20 blur-2xl" />
          <div className="relative">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-sm font-semibold text-background-50 backdrop-blur">
              <i className="ri-water-flash-line" aria-hidden="true" />
              今晚的瓜，还没吃完
            </span>
            <h2 className="mx-auto mt-5 max-w-2xl text-3xl font-black leading-tight text-background-50 md:text-5xl">
              来吃瓜m，和更多瓜友一起围观唠嗑
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
              在线围观、评论区见、瓜团讨论，随你挑，随你唠。点开就走，说走就聊，越唠瓜越香。
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#feed"
                onClick={(e) => go(e, "#feed")}
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3.5 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100 sm:w-auto"
              >
                <i className="ri-video-on-line text-lg" aria-hidden="true" />
                现在就围观
              </a>
              <a
                href="#play"
                onClick={(e) => go(e, "#play")}
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/60 px-7 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/15 sm:w-auto"
              >
                看看怎么唠
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* footer */}
      <div className="bg-accent-950 text-background-100">
        <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
          <div className="flex flex-col gap-10 md:flex-row md:justify-between">
            <div className="max-w-sm">
              <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-700 text-lg text-background-50">
                  <i className="ri-water-flash-line" aria-hidden="true" />
                </span>
                <span className="text-lg font-extrabold text-background-50">
                  吃瓜<span className="text-accent-300">m</span>
                </span>
              </a>
              <p className="mt-4 text-sm leading-relaxed text-background-100/70">
                {brandName} 是一个主打在线围观、评论区见、聊瓜唠嗑与瓜团讨论的瓜友社区。热门瓜与日常话题都在这里，和同频的人一起吃瓜，越唠越香。
              </p>
              <div className="mt-5 flex flex-wrap gap-2 text-xs">
                {["在线围观", "评论区见", "聊瓜唠嗑", "瓜团讨论"].map((k) => (
                  <span key={k} className="whitespace-nowrap rounded-full bg-accent-800/70 px-3 py-1 text-accent-100">
                    {k}
                  </span>
                ))}
              </div>
            </div>

            <nav className="grid grid-cols-2 gap-x-10 gap-y-8 sm:grid-cols-3">
              <div>
                <h4 className="text-sm font-bold text-background-50">快速围观</h4>
                <ul className="mt-4 flex flex-col gap-3">
                  {navItems.map((n) => (
                    <li key={n.href}>
                      <a
                        href={n.href}
                        onClick={(e) => go(e, n.href)}
                        className="inline-flex whitespace-nowrap text-sm text-background-100/70 transition-colors hover:text-accent-200"
                      >
                        {n.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-bold text-background-50">热门栏目</h4>
                <ul className="mt-4 flex flex-col gap-3 text-sm text-background-100/70">
                  <li>明星八卦</li>
                  <li>综艺现场</li>
                  <li>网络热梗</li>
                  <li>生活趣事</li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-bold text-background-50">互动与反馈</h4>
                <ul className="mt-4 flex flex-col gap-3 text-sm text-background-100/70">
                  <li className="inline-flex items-center gap-2">
                    <i className="ri-mail-line" aria-hidden="true" />
                    建议反馈：hello@example.com
                  </li>
                  <li className="inline-flex items-center gap-2">
                    <i className="ri-chat-smile-3-line" aria-hidden="true" />
                    理性发言，友善吃瓜
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-accent-800/70 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center">
            <p>© {year} {brandName} · 陪你一起在线围观、评论区见</p>
            <p className="whitespace-nowrap">本站为内容分享社区 · 请理性发言、尊重事实</p>
          </div>
        </div>
      </div>
    </footer>
  );
}